import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';

import Component from "components/component";
import { formatUpchargeAmount } from "lib/helpers";

export default class DefaultOption extends Component {
  static propTypes = {
    optionValue: ImmutablePropTypes.map,
    isSelected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    selectable: PropTypes.bool.isRequired,
    noMargin: PropTypes.bool,
    displayUpchargeAmountOverride: PropTypes.string,
    inSlider: PropTypes.bool
  };

  render() {
    const {
      isSelected,
      optionValue,
      handleClick,
      selectable,
      noMargin,
      displayUpchargeAmountOverride,
      inSlider,
      displayNameOverride,
      thumbnailImageOverride,
      containerStyles = {},
      imageStyles = {},
      titleStyles = {},
    } = this.props;
    const {
      id,
      displayName,
      thumbnailImage,
      displayUpchargeAmount,
      metaData
    } = optionValue.toObject();
    let classSet = ["selection"];
    let onClick = handleClick.bind(this, id);
    let upchargeAmount = displayUpchargeAmount;
    const upchargeLabel = optionValue.getIn([
      "upchargeConfiguration",
      "upchargeLabel"
    ]);

    const {
      additionalDetail
    } = metaData.toObject();

    const htmlId = inSlider
      ? `option_value_${id}_slider`
      : `option_value_${id}`;

    if (isSelected) {
      classSet.push("selection-selected");
    }

    if (!selectable) {
      classSet.push("unselectable");
      onClick = null;
    }

    if (noMargin) {
      classSet.push("no-margin");
    }

    if (displayUpchargeAmountOverride) {
      upchargeAmount = displayUpchargeAmountOverride;
    }

    if (upchargeLabel) {
      upchargeAmount = upchargeLabel;
    }

    return (
      <div
        onClick={onClick}
        key={id}
        className={classSet.join(" ")}
        id={htmlId}
        style={containerStyles}
      >
        <img style={imageStyles} src={`${thumbnailImageOverride || thumbnailImage}?w=195&h=195`} />
        <div className="selection-details">
          <p style={titleStyles} className="selection-details-title">{displayNameOverride || displayName}</p>
          {additionalDetail && (
            <p className="selection-additional-detail">
              <em>{additionalDetail}</em>
            </p>
          )}
          {!additionalDetail && (
            <p className="selection-additional-detail">
              <span>&nbsp;</span>
            </p>
          )}
        </div>
      </div>
    );
  }
}
